import { FastumTicket, fastumTicketSchema } from "@boark/shared/types/fastum-ticket";
import { fastumTicketsWithIssuesSchema } from "@boark/shared/types/fastum-ticket-with-issues";

import { getRequest } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getFastumTickets() {
  return getRequest(
    `${API_BASE_URL}/fastum/ticket`,
    fastumTicketsWithIssuesSchema,
  );
}

export async function getFastumTicket(id: string): Promise<FastumTicket> {
  return getRequest(`${API_BASE_URL}/fastum/ticket/${id}`, fastumTicketSchema);
}

export async function importFastumTickets(): Promise<void> {
  await getRequest(`${API_BASE_URL}/fastum/import`);
}
